import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async initializeContext(store) {
    const { commit, dispatch } = store;
    return await axios({
      url: `/v1/events/list?page=1&per_page=15&order=id&mode=desc`,
      method: 'GET',
    })
      .then(async (resp) => {
        if (resp.data && resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        const event = resp.data.data[0];
        const eventId = !!event ? event.id : null;
        commit('setEventContext', eventId);
        dispatch('updateContext');
        return Promise.resolve(event);
      })
      .catch(resp => parseApiError(resp));
  },
  async updateContext(store) {
    const { dispatch } = store;
    await Promise.all([
      dispatch('getControlPointsStats'),
      dispatch('getManualNotifications'),
      dispatch('getAutomatedNotifications'),
      dispatch('getControlPoints'),
      dispatch('getProjects'),
    ]);
  },
  async getControlPointsStats(store) {
    const { state, commit } = store;
    if (!state.eventContext) return;
    return await axios({
      url: `/v1/events/${state.eventContext}/control_points/stats`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        const data = resp.data.data;
        commit('setControlPointsStats', data);
        return Promise.resolve(data);
      })
      .catch(resp => parseApiError(resp));
  },
  async getNotifications(store) {
    const { state, commit } = store;
    if (!state.eventContext) return;
    return await axios({
      url: `/v1/events/${state.eventContext}/notifications?per_page=30&order=id&mode=desc`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        const data = resp.data.data;
        commit('setNotifications', data);
        return Promise.resolve(data);
      })
      .catch(resp => parseApiError(resp));
  },
  async getManualNotifications(store) {
    const { state, commit } = store;
    if (!state.eventContext) return;
    let link = `/v1/events/${state.eventContext}/notifications`;
    link = `${link}?per_page=20&order=id&mode=desc`;
    link = `${link}&include=event,project,control_point,control_point_request`;
    link = `${link}&notification_types[0]=manual`;
    return await axios({
      url: link,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        const data = resp.data.data;
        commit('setManualNotifications', data);
        return Promise.resolve(data);
      })
      .catch(resp => parseApiError(resp));
  },
  async getAutomatedNotifications(store) {
    const { state, commit } = store;
    if (!state.eventContext) return;
    let link = `/v1/events/${state.eventContext}/notifications`;
    link = `${link}?per_page=20&order=id&mode=desc`;
    link = `${link}&include=event,project,control_point,control_point_request`;
    link = `${link}&notification_types[0]=control_point_request_created`;
    link = `${link}&notification_types[1]=critical_control_point_closure_requested`;
    link = `${link}&notification_types[2]=control_point_deadline_approaching`;
    link = `${link}&notification_types[3]=control_point_request_resolved`;
    link = `${link}&notification_types[4]=critical_control_point_closure_resolved`;
    link = `${link}&notification_types[5]=project_completed`;
    return await axios({
      url: link,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        const data = resp.data.data;
        commit('setAutomatedNotifications', data);
        return Promise.resolve(data);
      })
      .catch(resp => parseApiError(resp));
  },
  async getControlPoints(store) {
    const { state, commit } = store;
    if (!state.eventContext) return;
    let link = `/v1/events/${state.eventContext}/control_points`;
    link = `${link}?per_page=50`;
    link = `${link}&execution_statuses[0]=in_progress`;
    link = `${link}&execution_statuses[1]=waiting_for_approval`;
    link = `${link}&execution_statuses[2]=in_closure_process`;
    return await axios({
      url: link,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        const data = resp.data.data;
        commit('setControlPoints', data);
        return Promise.resolve(data);
      })
      .catch(resp => parseApiError(resp));
  },
  async getProjects(store) {
    const { state, commit } = store;
    if (!state.eventContext) return;
    return await axios({
      url: `/v1/events/${state.eventContext}/projects?include=fnd,responsible,attachments&per_page=50&order=id&mode=desc`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        const data = resp.data.data;
        commit('setProjects', data);
        return Promise.resolve(data);
      })
      .catch(resp => parseApiError(resp));
  },
};

export default actions;
